var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-screen-sec",attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }